import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('hotelNewsletter');
export const actions = helper.createActions('hotelNewsletter', actionTypes);
